<template>
	<div style="margin:10px; font-size:18px;">
		<p>--Debug--</p>
		<p v-if="htmlPing==-1">value 1 : ERROR</p><p v-else>value 1 : {{htmlPing}}ms</p>
		<p v-if="nodePing==-1">value 2 : ERROR</p><p v-else>value 2 : {{nodePing}}ms</p>
		<p v-if="mysqlPing==-1">value 3 : ERROR</p><p v-else>value 3 : {{mysqlPing}}ms</p>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
	name: 'Debug',
	data() {
		return {
			htmlPing:0,
			nodePing:0,
			mysqlPing:0,
			pingsSent:false,
		}
	},
	async created () {
		this.ping();
	},
	methods:{
		ping() {
			this.pingHtml();
			this.pingNode();
			this.pingMysql();
		},
		pingHtml() {
			let start = Date.now()

			api.getDebugHtml().then((res) => {
				if(res.status==200){
					let finish = Date.now()
					let time = finish - start
					this.htmlPing = time;
				}else{
					this.htmlPing=-1;
				}
			}).finally((res) => {
				this.checkPings()
				setTimeout(() => {
					//this.pingHtml()
				},1000);
			})
		},
		pingNode() {
			let start = Date.now()

			api.getDebug().then((res) => {
				if(res.status==200){
					let finish = Date.now()
					let time = finish - start
					this.nodePing = time;
				}else{
					this.nodePing=-1;
				}
			}).finally((res) => {
				this.checkPings()
				setTimeout(() => {
					//this.pingNode()
				},1000);
			})
		},
		pingMysql() {
			let start = Date.now()

			api.postData(
				{
					type:"debug",
					data:{}
				}
			).then((res) => {
				if(res.status==200 && res.data.data!=null && res.data.data.column_data!=null && res.data.data.column_data.length==1){
					let finish = Date.now()
					let time = finish - start
					this.mysqlPing = time;
				}else{
					this.mysqlPing=-1;
				}
			}).finally((res) => {
				this.checkPings()
				setTimeout(() => {
					//this.pingMysql()
				},1000);
			})
		},
		checkPings(){
			if(this.pingsSent==false && this.htmlPing != 0 && this.nodePing != 0 && this.mysqlPing != 0){
				this.pingsSent = true;
				//alert("DONE")
				api.postData(
					{
						type:"debug",
						data:{
							log:"HTML:"+this.htmlPing+"ms; NODE:"+this.nodePing+"ms; MYSQL:"+this.mysqlPing+"ms"
						}
					}
				)
			}
		}
	},
}
</script>

<style scoped>
.frame{
	/*  583.5/2=291.75  */
	margin-left:calc(50% - 291.75pt);
    width:583.5pt;
    height:calc(100vh - 60px);
    border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/Debug.vue